import * as React from 'react'
import { IconsModel } from './iconsModel'

function SvgGarage(
	{
		color,
		width = 50,
		height = 50
	}: IconsModel
) {
	return (
		<svg width={width} height={height} viewBox="0 0 348.66 178.62">
			<defs>
				<style>{`.cls-1{fill:${color}`}</style>
			</defs>
			<path className="cls-1"
			      d="M375.27,221.64c-7.81-10.79-22.9-16.68-34.41-18.6l-62-10.33-42.76-64.14H127.59v8.5h104l36.85,55.28h-95l-9.83-39.3-8.25,2.06,11.44,45.74H276l63.43,10.57c9.4,1.57,22.61,6.49,28.92,15.21a52.53,52.53,0,0,1,10.05,31v19.76h-17v8.5h25.51V257.63A61,61,0,0,0,375.27,221.64Z"
			      transform="translate(-38.27 -128.57)" />
			<path className="cls-1"
			      d="M46.77,217.86a17,17,0,0,1,17-17h85v-8.5H68.08a56.25,56.25,0,0,1,16.1-36.93,60.76,60.76,0,0,1,43.38-18.35v-8.5A69.31,69.31,0,0,0,78.07,149.5a64.65,64.65,0,0,0-18.53,43.2,25.56,25.56,0,0,0-21.27,25.16v10.63h8.5Z"
			      transform="translate(-38.27 -128.57)" />
			<path className="cls-1" d="M308.27,224.2a41.47,41.47,0,0,0-39.81,53.19H124.85a41.6,41.6,0,1,0-3.58,8.5H272a41.49,41.49,0,1,0,36.23-61.69Z" transform="translate(-38.27 -128.57)" />
		</svg>
	)
}

export default SvgGarage
